import React, { Component } from "react";
import {
  View,
  StatusBar,
  Text,
  TouchableOpacity,
  Image,
} from "react-native-web";
import BackgroundImage from "../components/BackgroundImage";
import HeaderBar from "../components/HeaderBar";
import gql from "graphql-tag";
import { withRouter } from "react-router";
import { LoadingOverlay } from "../components/Overlay";
import { ApolloConsumer, Mutation } from "react-apollo";
import { withI18n, translate } from "../libs/withI18n";
import { addNotification } from "../App";
import { handleError } from "../libs/errors";
import ApolloClient from "apollo-boost";
import localforage from "localforage";
import firebaseConfig from "../firebaseConfig.json";
import "firebase/messaging";
import firebase from "firebase/app";

// This page talks to the MWV API, not the main SchoolLife API that the rest
// of the PWA uses (see src/libs/initApollo.js). lookupStudentByUniqueCode,
// phoneStatusForClaim and registerByUniqueCode only exist on MWV, so we build
// a dedicated client for this page, same as src/pages/claim_student.js does.
const mwvClient = new ApolloClient({
  uri: "https://api.mwv.softwaresekolah.co.id/graphql",
  credentials: "same-origin",
});

const DEVICE_ID_STORAGE_KEY = "registerByCodeDeviceId";

// deviceId must stay stable per browser: the server rate-limits on it, so a
// value that changes on every call defeats the limiter, and an empty value is
// rejected outright. localStorage keeps it stable across visits; if
// localStorage throws (private mode) we still hand back a fresh id instead of
// an empty string so the request can go through.
const generateDeviceId = () => {
  const character =
    "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
  let id = "";
  for (let i = 0; i < 24; i++) {
    id += character[Math.floor(Math.random() * character.length)];
  }
  return `pwa-${Date.now()}-${id}`;
};

const getOrCreateDeviceId = () => {
  try {
    let deviceId = window.localStorage.getItem(DEVICE_ID_STORAGE_KEY);
    if (!deviceId) {
      deviceId = generateDeviceId();
      window.localStorage.setItem(DEVICE_ID_STORAGE_KEY, deviceId);
    }
    return deviceId;
  } catch (e) {
    return generateDeviceId();
  }
};

const STEP_UNIQUE_CODE = 1;
const STEP_PHONE = 2;
const STEP_FINISH = 3;

class RegisterByCode extends Component {
  state = {
    step: STEP_UNIQUE_CODE,
    loading: false,
    deviceId: "",
    uniqueCode: "",
    claimTicket: "",
    studentName: "",
    schoolName: "",
    className: "",
    phone: "",
    phoneStatus: "",
    name: "",
    password: "",
  };

  componentDidMount() {
    this.setState({
      deviceId: getOrCreateDeviceId(),
    });
  }

  refresh = () => {
    window.location.reload();
  };

  handleInput = (key) => (e) => {
    this.setState({
      [key]: e.target.value,
    });
  };

  handleInputPhone = (e) => {
    this.setState({
      phone: e.target.value.replace(/\D/g, ""),
    });
  };

  handleBack = () => {
    if (this.state.step === STEP_FINISH) {
      this.setState({
        step: STEP_PHONE,
        phoneStatus: "",
        password: "",
      });
    } else if (this.state.step === STEP_PHONE) {
      this.setState({
        step: STEP_UNIQUE_CODE,
        claimTicket: "",
        studentName: "",
        schoolName: "",
        className: "",
        phone: "",
        phoneStatus: "",
      });
    } else {
      this.props.history.push({
        pathname: "/login",
      });
    }
  };

  handleLookupStudent = async (e) => {
    if (e) e.preventDefault();
    if (!this.state.uniqueCode) {
      return handleError({
        message: "Kode unik tidak boleh kosong!",
      });
    }
    this.setState({
      loading: true,
    });
    try {
      const response = await mwvClient.mutate({
        mutation: LOOKUP_STUDENT_BY_UNIQUE_CODE,
        variables: {
          uniqueCode: this.state.uniqueCode,
          deviceId: this.state.deviceId || getOrCreateDeviceId(),
        },
        fetchPolicy: "no-cache",
      });
      const result =
        response.data && response.data.lookupStudentByUniqueCode
          ? response.data.lookupStudentByUniqueCode
          : null;

      if (!result || !result.claimTicket) {
        this.setState({
          loading: false,
        });
        return handleError({
          message: "Kode unik tidak ditemukan!",
        });
      }

      this.setState({
        loading: false,
        step: STEP_PHONE,
        claimTicket: result.claimTicket,
        studentName: result.studentName,
        schoolName: result.schoolName,
        className: result.className,
      });
    } catch (e) {
      this.setState({
        loading: false,
      });
      handleError({
        message: e.message.replace("GraphQL error: ", ""),
      });
    }
  };

  handleCheckPhone = async (e) => {
    if (e) e.preventDefault();
    if (!this.state.phone) {
      return handleError({
        message: "Nomor Whatsapp tidak boleh kosong!",
      });
    }
    this.setState({
      loading: true,
    });
    try {
      const response = await mwvClient.mutate({
        mutation: PHONE_STATUS_FOR_CLAIM,
        variables: {
          claimTicket: this.state.claimTicket,
          phone: this.state.phone,
        },
        fetchPolicy: "no-cache",
      });
      const phoneStatus =
        response.data && response.data.phoneStatusForClaim
          ? response.data.phoneStatusForClaim
          : "";

      if (!phoneStatus) {
        this.setState({
          loading: false,
        });
        return handleError({
          message: "Server Error!",
        });
      }

      this.setState({
        loading: false,
        phoneStatus,
        step: phoneStatus === "CLAIMED_BY_OTHER" ? STEP_PHONE : STEP_FINISH,
      });
    } catch (e) {
      this.setState({
        loading: false,
      });
      handleError({
        message: e.message.replace("GraphQL error: ", ""),
      });
    }
  };

  handleRegister = async (e) => {
    if (e) e.preventDefault();
    const { phoneStatus, name, password } = this.state;

    if (!password) {
      return handleError({
        message: "Password tidak boleh kosong!",
      });
    }
    if (phoneStatus === "NEW" && !name) {
      return handleError({
        message: "Nama lengkap tidak boleh kosong!",
      });
    }

    this.setState({
      loading: true,
    });
    try {
      const variables = {
        claimTicket: this.state.claimTicket,
        phone: this.state.phone,
        password,
      };
      if (phoneStatus === "NEW") {
        variables.name = name;
      }

      const response = await mwvClient.mutate({
        mutation: REGISTER_BY_UNIQUE_CODE,
        variables,
        fetchPolicy: "no-cache",
      });
      const AccountSession =
        response.data && response.data.registerByUniqueCode
          ? response.data.registerByUniqueCode
          : null;

      if (!AccountSession) {
        this.setState({
          loading: false,
        });
        return handleError({
          message: "Server Error!",
        });
      }

      addNotification({
        title: "SUCCESS",
        message: `Berhasil mendaftar akun`,
        level: "success",
      });

      return this.persistSessionAndEnter(AccountSession);
    } catch (e) {
      this.setState({
        loading: false,
      });
      handleError({
        message: e.message.replace("GraphQL error: ", ""),
      });
    }
  };

  // Mirrors src/pages/register.js (logInWithGoogleOrWhatsapp) and
  // src/pages/input_otp.js (logInWithOtp): this PWA is not inside the native
  // WebView, so there is no window.ReactNativeWebView to hand the session to
  // -- the session is persisted in localforage and the parent is sent to
  // /explore.
  persistSessionAndEnter = async (AccountSession) => {
    if (!firebase.apps.length) {
      firebase.initializeApp(firebaseConfig);
    }
    if (firebase.messaging.isSupported()) {
      const messaging = firebase.messaging();
      await messaging.requestPermission();
    }

    localforage.setItem("accountSession", JSON.stringify(AccountSession));

    if (firebase.messaging.isSupported()) {
      const messaging = firebase.messaging();
      const fcmToken = await messaging.getToken();
      localforage.setItem("fcm-token", fcmToken);
      await this.props.resubscribeTopicForPushNotification({
        variables: {
          fcmToken,
        },
      });
    }

    this.setState({
      loading: false,
    });

    setTimeout(() => {
      window.location = "/explore";
    }, 1000);
  };

  renderStepUniqueCode = () => (
    <div className="card-body">
      <p className="text-center">
        {translate("Masukkan Kode Unik Siswa Di Bawah Ini")}.
      </p>
      <div className="form-group">
        <label>{translate("Kode Unik Siswa")}</label>
        <input
          style={{ textAlign: "center" }}
          type="text"
          className="form-control"
          placeholder="Masukkan kode unik..."
          maxLength={15}
          value={this.state.uniqueCode}
          onChange={this.handleInput("uniqueCode")}
        />
      </div>
      <button
        type="button"
        className="btn btn-block btn-primary mt-3"
        onClick={this.handleLookupStudent}
      >
        <i className="fa fa-search" /> Cari
      </button>
    </div>
  );

  renderStepPhone = () => (
    <div className="card-body">
      <hr />
      <h6 className="text-bold text-center" style={{ fontWeight: "bold" }}>
        {translate("Siswa ditemukan")}!
      </h6>
      <table className="w-100">
        <thead>
          <tr>
            <th width="20%" />
            <th width="5%" />
            <th width="75%" />
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{translate("Nama")}</td>
            <td>:</td>
            <td>{this.state.studentName}</td>
          </tr>
          <tr>
            <td>{translate("Sekolah")}</td>
            <td>:</td>
            <td>{this.state.schoolName}</td>
          </tr>
          <tr>
            <td>{translate("Kelas")}</td>
            <td>:</td>
            <td>{this.state.className}</td>
          </tr>
        </tbody>
      </table>
      <hr />
      <div className="form-group">
        <label>{translate("Nomor Whatsapp Orang Tua/Wali")}</label>
        <input
          type="text"
          className="form-control"
          placeholder="Contoh: 081234567890"
          value={this.state.phone}
          onChange={this.handleInputPhone}
        />
      </div>

      {this.state.phoneStatus === "CLAIMED_BY_OTHER" ? (
        <div className="text-center mb-3">
          <Image
            style={{
              width: 100,
              height: 100,
              margin: "auto",
            }}
            source={require("../assets/user-remove-denied-male-asian.png")}
          />
          <p className="text-danger mt-2">
            {translate(
              "Siswa ini sudah terdaftar pada akun lain. Silakan hubungi pihak sekolah untuk bantuan."
            )}
            .
          </p>
        </div>
      ) : null}

      <button
        type="button"
        className="btn btn-block btn-primary"
        onClick={this.handleCheckPhone}
      >
        <i className="fa fa-arrow-right" /> Lanjutkan
      </button>
    </div>
  );

  renderStepFinish = () => {
    const { phoneStatus } = this.state;
    let helperText = "";
    if (phoneStatus === "NEW") {
      helperText =
        "Nomor Anda belum memiliki akun. Lengkapi nama dan buat password baru.";
    } else if (phoneStatus === "EXISTING_ATTACH") {
      helperText =
        "Nomor Anda sudah memiliki akun. Masukkan password akun tersebut untuk menambahkan siswa ini.";
    } else if (phoneStatus === "EXISTING_RESET") {
      helperText =
        "Siswa ini sudah tertaut pada akun dengan nomor ini. Buat password baru untuk akun Anda.";
    }

    return (
      <div className="card-body">
        <p className="text-center">{translate(helperText)}.</p>

        {phoneStatus === "NEW" ? (
          <div className="form-group">
            <label>{translate("Nama Lengkap")}</label>
            <input
              type="text"
              className="form-control"
              placeholder="Masukkan nama lengkap anda"
              value={this.state.name}
              onChange={this.handleInput("name")}
            />
          </div>
        ) : null}

        <div className="form-group">
          <label>
            {phoneStatus === "EXISTING_ATTACH"
              ? translate("Password Akun")
              : translate("Password Baru")}
          </label>
          <input
            type="password"
            className="form-control"
            placeholder={
              phoneStatus === "EXISTING_ATTACH"
                ? "Masukkan password akun anda"
                : "Buat password baru"
            }
            value={this.state.password}
            onChange={this.handleInput("password")}
          />
        </div>

        <button
          type="button"
          className="btn btn-block btn-primary"
          onClick={this.handleRegister}
        >
          <i className="fa fa-user-check" /> {translate("Daftar")}
        </button>
      </div>
    );
  };

  render() {
    const { loading, step } = this.state;
    return (
      <View style={{ flex: 1 }}>
        <div className="fixed-top">
          <StatusBar
            backgroundColor="#1696ff"
            barStyle="light-content"
            animated={true}
          />
        </div>
        <LoadingOverlay visible={loading} />
        <BackgroundImage />

        <div className="fixed-top">
          <HeaderBar
            title={
              <TouchableOpacity onPress={this.handleBack}>
                <Text>
                  <i
                    className="fa fa-arrow-left"
                    style={{
                      fontSize: 20,
                    }}
                  />{" "}
                  {translate("Kembali")}
                </Text>
              </TouchableOpacity>
            }
          />
        </div>
        <div
          className="card"
          style={{ borderRadius: "20px", margin: "auto 15px" }}
        >
          <div
            className="card-header text-center"
            style={{
              backgroundColor: "#10ac84",
              borderRadius: "20px 20px 0 0",
              color: "#fff",
            }}
          >
            <h4>{translate("Daftar Dengan Kode Unik Siswa")}</h4>
          </div>

          {step === STEP_UNIQUE_CODE ? this.renderStepUniqueCode() : null}
          {step === STEP_PHONE ? this.renderStepPhone() : null}
          {step === STEP_FINISH ? this.renderStepFinish() : null}
        </div>
      </View>
    );
  }
}

const LOOKUP_STUDENT_BY_UNIQUE_CODE = gql`
  mutation lookupStudentByUniqueCode(
    $uniqueCode: String!
    $deviceId: String!
  ) {
    lookupStudentByUniqueCode(uniqueCode: $uniqueCode, deviceId: $deviceId) {
      claimTicket
      studentName
      schoolName
      className
    }
  }
`;

const PHONE_STATUS_FOR_CLAIM = gql`
  mutation phoneStatusForClaim($claimTicket: String!, $phone: String!) {
    phoneStatusForClaim(claimTicket: $claimTicket, phone: $phone)
  }
`;

const REGISTER_BY_UNIQUE_CODE = gql`
  mutation registerByUniqueCode(
    $claimTicket: String!
    $phone: String!
    $name: String
    $password: String!
  ) {
    registerByUniqueCode(
      claimTicket: $claimTicket
      phone: $phone
      name: $name
      password: $password
    ) {
      _id
      token
      expiresIn
      Account {
        _id
        name
        email
        phone
        status
        roles
        subscribedTopics
      }
      _createdAt
    }
  }
`;

const RESUBSCRIBE = gql`
  mutation resubscribeTopicForPushNotification($fcmToken: String!) {
    resubscribeTopicForPushNotification(fcmToken: $fcmToken)
  }
`;

export default withRouter(
  withI18n("saving")((props) => (
    <ApolloConsumer>
      {() => (
        <Mutation mutation={RESUBSCRIBE}>
          {(resubscribeTopicForPushNotification) => (
            <RegisterByCode
              {...props}
              resubscribeTopicForPushNotification={
                resubscribeTopicForPushNotification
              }
            />
          )}
        </Mutation>
      )}
    </ApolloConsumer>
  ))
);
